"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = SaveTo;

var _SaveTo = require("@adobe/react-spectrum-workflow/dist/SaveTo");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function SaveTo(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_SaveTo.A4uSaveTo, null));
}